'use strict';

import CnSmartFtp from './cn-smart-ftp';
import CnSmartFtpLite from './cn-smart-ftp-lite';
import CnSmartForm from './cn-smart-form';
import CnSmartDetail from './cn-smart-detail';

// 通过arr控制输出的顺序
var bundle = [
  CnSmartFtp,
  CnSmartFtpLite,
  CnSmartForm,
  CnSmartDetail
];

export default bundle;
export {
  CnSmartFtp,
  CnSmartFtpLite,
  CnSmartForm,
  CnSmartDetail
};
